function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import PropTypes from "prop-types";
import Image from "../Image/index.js";
import { useInView } from "react-intersection-observer";
import { ProductImpression, ClickThroughProduct } from "../../utils/analytics.js";
import ProductCardHeading from "./ProductCardHeading.js";
import styles from "./styles.css";
import TopPickBadge from "../TopPickBadge/index.js";
import Loading from "./Loading.js";
var ProductCard = function ProductCard(_ref) {
  var index = _ref.index,
    imageProps = _ref.imageProps,
    product = _ref.product,
    modalComponent = _ref.modalComponent,
    modalEntryPoint = _ref.modalEntryPoint,
    modalCtaUrl = _ref.modalCtaUrl,
    favoriteComponent = _ref.favoriteComponent,
    layoutProps = _ref.layoutProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    firstView = _useState4[0],
    setFirstView = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth <= 768;
  var handleImageLoad = function handleImageLoad() {
    setLoaded(true);
  };
  var loadModal = function loadModal() {
    return index && index == modalEntryPoint;
  };
  var getProductSource = function getProductSource(source) {
    if (source) {
      return source;
    }
    return layoutProps.is_unfiltered_page ? "unfiltered results page" : "filtered results page";
  };
  var _useInView = useInView({
      triggerOnce: true,
      rootMargin: "0px",
      threshold: 0.5,
      // eslint-disable-next-line no-shadow
      onChange: function onChange(inView) {
        if (inView) {
          setFirstView(true);
          setShowModal(loadModal());
          ProductImpression(_objectSpread(_objectSpread({}, product.analyticsProps), {}, {
            productId: product.id,
            alternate_view: false,
            action: "none",
            source: getProductSource(layoutProps.source),
            firstView: firstView,
            resultsCount: layoutProps.resultsCount,
            position: layoutProps.position,
            pageCount: layoutProps.pageCount,
            resultsPosition: layoutProps.position,
            platform: layoutProps.is_mobile ? "mobile web" : "desktop web"
          }));
        }
      }
    }),
    ref = _useInView.ref;
  var handleClickThroughProduct = function handleClickThroughProduct() {
    ClickThroughProduct(_objectSpread(_objectSpread({}, product.analyticsProps), {}, {
      productId: product.id,
      alternateView: false,
      action: "click",
      source: getProductSource(layoutProps.source),
      firstView: firstView,
      resultsCount: layoutProps.resultsCount,
      position: layoutProps.position,
      pageCount: layoutProps.pageCount,
      resultsPosition: layoutProps.position,
      platform: layoutProps.is_mobile ? "mobile web" : "desktop web"
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "".concat(styles.productCard, " result-item"),
    style: {
      display: loaded ? "block" : "none"
    }
  }, favoriteComponent && favoriteComponent(_objectSpread(_objectSpread({
    id: "favorite_".concat(product.id)
  }, product.favorite_data), {}, {
    favorite_params: _objectSpread({}, product.favorite_data)
  })), /*#__PURE__*/React.createElement("a", {
    href: product.relativeUrl,
    className: styles.productCardLink,
    onClick: handleClickThroughProduct
  }, product.topPick && /*#__PURE__*/React.createElement(TopPickBadge, {
    product: product
  }), /*#__PURE__*/React.createElement(Image, {
    imageProps: imageProps,
    onLoad: handleImageLoad,
    index: index
  }), /*#__PURE__*/React.createElement(ProductCardHeading, {
    productDesignerName: product.designerName,
    productName: product.productStyle,
    price: product.productPricePoint,
    showPrice: product.showPrice && !product.priceEstimated
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: loaded ? "none" : "block"
    }
  }, /*#__PURE__*/React.createElement(Loading, {
    isMobile: isMobile
  })), showModal && modalComponent ? modalComponent({
    id: "modal_".concat(product.id),
    isOpen: showModal,
    closeModal: function closeModal() {
      return setShowModal(false);
    },
    quizUrl: modalCtaUrl
  }) : null);
};
process.env.NODE_ENV !== "production" ? ProductCard.propTypes = {
  imageProps: PropTypes.object.isRequired,
  product: PropTypes.shape({
    relativeUrl: PropTypes.string.isRequired,
    topPick: PropTypes.bool,
    designerName: PropTypes.string.isRequired,
    productStyle: PropTypes.string.isRequired,
    productPricePoint: PropTypes.string,
    priceEstimated: PropTypes.bool,
    showPrice: PropTypes.bool
  }).isRequired
} : void 0;
export default ProductCard;